import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.checkboxTargets.forEach((checkbox) => this.setIndeterminate(checkbox))
  }

  checkboxTargetConnected(checkbox) {
    this.setIndeterminate(checkbox)
  }

  submit(event) {
    event.target.form.requestSubmit()
  }

  print() {
    window.print()
  }

  setIndeterminate(checkbox) {
    checkbox.indeterminate = checkbox.dataset.indeterminate === "true"
  }
}
